import { Fragment, React } from 'react';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import CircularProgress from '@material-ui/core/CircularProgress';

import ImagesComponent from './ImagesComponent';
import classes from './ShortlistTable.module.css';

import dragHandle from '../../assets/img/dragIcon.svg';
import useAddShortlistedoption from '../../store/contexts/useAddShortlistedoption';
import { reorderShortListData } from '../../utils/utils';

const NotesTable = ({ shortlist, surveyData }) => {
  const data = useSelector((state) => state.optRed.data);

  let shortListCopy = reorderShortListData(shortlist);

  const { putOption, inProgress } = useAddShortlistedoption();
  const dispatch = useDispatch();

  const dragendHandler = (params) => {
    if (!params.destination || params.destination.index === params.source.index) return;
    const srcI = params.source.index;
    const desI = params.destination.index;

    shortListCopy.splice(desI, 0, shortListCopy.splice(srcI, 1)[0]);

    shortListCopy = shortListCopy.map((obj, index) => ({
      ...obj,
      shortlistedOrder: index + 1,
    }));

    const ids = shortListCopy.map((item) => item.optionId);

    putOption(
      () => {
        dispatch({
          type: 'SET_SHORTLIST_IDS',
          ids: ids,
        });
      },
      'RESET',
      ids,
      shortListCopy,
    );
  };

  return (
    <Fragment>
      <NotesTableWrapper>
        <thead>
          <tr>
            <th style={{ minWidth: '40px' }}>
              <img src={dragHandle} alt=".." />
            </th>
            <th style={{ minWidth: '250px' }}>Photos</th>
            <th style={{ minWidth: '200px', whiteSpace: 'nowrap' }}>Name</th>
            <th style={{ width: '100%' }}>Notes</th>
          </tr>
        </thead>
        {typeof shortListCopy === 'undefined' && (
          <tbody>
            <tr>
              <td colSpan="8" style={{ textAlign: 'center' }}>
                Nothing is shortlisted
              </td>
            </tr>
          </tbody>
        )}
        <DragDropContext onDragEnd={dragendHandler}>
          <Droppable droppableId="droppale-4">
            {(provided, _) => (
              <tbody ref={provided.innerRef} {...provided.droppableProps}>
                {shortListCopy &&
                  shortListCopy.map((item, idx) => (
                    <Draggable key={item.id} draggableId={'draggable4-' + item.id} index={idx}>
                      {(provided, snapshot) => (
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={{
                            ...provided.draggableProps.style,
                            boxShadow: snapshot.isDragging ? '0 0 0.4rem #666' : '',
                            zIndex: '200',
                          }}
                        >
                          <td
                            style={{ width: '40px', height: '130px' }}
                            {...provided.dragHandleProps}
                          >
                            {<img src={dragHandle} alt=".." />}
                          </td>
                          <td style={{ width: '250px', height: '130px' }}>
                            <ImagesComponent images={item.images} width="200px" height="110px" />
                          </td>

                          <td
                            style={{ maxWidth: '150px', height: '130px', wordBreak: 'break-word' }}
                          >
                            {item.optionName}
                          </td>
                          <td style={{ wordBreak: 'break-word' }} className="removing_extra_space">
                            {item.notes && (
                              <span dangerouslySetInnerHTML={{ __html: item.notes }} />
                            )}
                            {(item.queryData || data.commonQuestions || item.commonQuestions) && (
                              <div>
                                <span>
                                  <b>Question(s) </b> <br />
                                </span>
                                {item.queryData && (
                                  <div dangerouslySetInnerHTML={{ __html: item?.queryData }} />
                                )}

                                {data &&
                                  data.commonQuestions &&
                                  data.commonQuestions.split('/n').map((q, i) => {
                                    if (q) {
                                      return (
                                        <div dangerouslySetInnerHTML={{ __html: q }} key={i} />
                                      );
                                    }
                                  })}

                                {item.commonQuestions &&
                                  item.commonQuestions.split('/n').map((q, i) => {
                                    if (q) {
                                      return (
                                        <div dangerouslySetInnerHTML={{ __html: q }} key={i} />
                                      );
                                    }
                                  })}
                              </div>
                            )}
                            {item.queryResponse && (
                              <div>
                                <span>
                                  <b>Response(s) </b> <br />
                                </span>
                                {item.queryResponse && (
                                  <div dangerouslySetInnerHTML={{ __html: item.queryResponse }} />
                                )}
                                <br />
                              </div>
                            )}
                          </td>
                        </tr>
                      )}
                    </Draggable>
                  ))}
              </tbody>
            )}
          </Droppable>
        </DragDropContext>
        {inProgress && (
          <span className={classes.spinner}>
            <CircularProgress color="inherit" />
          </span>
        )}
      </NotesTableWrapper>
    </Fragment>
  );
};

export default NotesTable;

const NotesTableWrapper = styled.div`
  & .removing_extra_space span * {
    margin: 0;
  }
`;
